module.exports = __webpack_public_path__ + "static/media/thesis_pdf.81275b27.jpg";